import { render, staticRenderFns } from "./InsuranceCompanyServiceAdd.vue?vue&type=template&id=546509e8&scoped=true&"
import script from "./InsuranceCompanyServiceAdd.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyServiceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546509e8",
  null
  
)

export default component.exports